import { Component } from "react";
import { DataTableCell, DataTableRow } from "@cdk-uip/react-data-table";
import { Icon } from "@cdk-uip/react-icon";
import { Select } from "@cdk-uip/react-select";
import { FormattedMessage } from "react-intl";
import { Button, ButtonIcon } from "@cdk-uip/react-button";
import { CircularProgress } from "@cdk-uip/react-circular-progress";
import { SUBSCRIPTION_EVENTS, ASYNC_ACCESS_GRANT_EVENTS } from "./states";
import { Confirm } from "../components/Confirm";
import { SOLUTION_STATUS } from "../Utils/constants";

const ACTIVATE = "Activate";
const DEACTIVATE = "Deactivate";


class AsyncApi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      org: "",
      app: "",
      asyncApi: "",
      accessGrants: "",
      confirm: false
    };
  }
  static defaultProps = {
    apiProvisioningStatus: "inactive"
  };



  componentDidUpdate(prevProps) {
    const { asyncApiIntegration, onEvent, orgs } = this.props;
    const { org, asyncApi, app, accessGrants } = this.state;
    if (asyncApiIntegration && !asyncApi) {
      onEvent({
        event: SUBSCRIPTION_EVENTS.GET_ORG,
        orgId: asyncApiIntegration.asyncApi.orgId
      });
      this.setState({ asyncApi: asyncApiIntegration.asyncApi });
    }
    if (
      asyncApiIntegration &&
      !org &&
      orgs[asyncApiIntegration.asyncApi.orgId]
    ) {
      this.setState({ org: orgs[asyncApiIntegration.asyncApi.orgId] });
    }
    if (asyncApiIntegration && !app) {
      this.setState({ app: asyncApiIntegration.app });
    }
    if (
      asyncApiIntegration &&
      asyncApiIntegration.asyncApiAccessGrants &&
      !accessGrants
    ) {
      this.setState({ accessGrants: asyncApiIntegration.asyncApiAccessGrants });
    }
  }

  render() {
    const { status, apiProvisioningStatus, solutionInfo } = this.props;
    const { org, asyncApi, confirm } = this.state;

    return (
      <>
        {asyncApi ? (
          <DataTableRow key={asyncApi.id}>
            <DataTableCell nonNumeric>
              <Icon className={"c-icon__connection-listitem"}>settings</Icon>
              {asyncApi.name}
              <p className={"sm-api-type-subtitle"}>
                API Type:
                <p
                  style={{
                    fontWeight: "bold",
                    display: "inline-block",
                    margin: "0px"
                  }}
                >
                  &nbsp;{"Async"}
                </p>
              </p>
            </DataTableCell>
            <DataTableCell nonNumeric>
              <Select
                className={"c-provider-select--disabled"}
                fullWidth
                allowEmpty={false}
                disabled={true}
                label="Current Provider"
                value="The provider name"
              >
                <option value={org ? org.name : "Loading"}>
                  {org ? org.name : "Loading"}
                </option>
              </Select>
            </DataTableCell>
            <DataTableCell nonNumeric>
              <p
                data-status={status}
                className={
                  `c-status-indicator c-status-indicator-double-stack c-status-indicator--${status}`
                }
              >
                <Icon>brightness_1</Icon>
                Dealer {status}
              </p>
              <p
                data-status={apiProvisioningStatus}
                className={
                  `c-status-indicator c-status-indicator-double-stack c-status-indicator--${apiProvisioningStatus}`
                }
              >
                <Icon>brightness_1</Icon>
                Prov. {apiProvisioningStatus}
              </p>
            </DataTableCell>
          </DataTableRow>
        ) : (
          <DataTableRow>
            <DataTableCell nonNumeric>
              <CircularProgress />
            </DataTableCell>
          </DataTableRow>
        )}
      </>
    );
  }
}

export default AsyncApi;
